// components/steps/StepTransport.jsx
import React, { useState, useEffect } from 'react';

const transportOptions = [
  'Flying',
  'Driving',
  'Train',
  'Boat',
  'Bus',
  'Not specified'
];

const StepTransport = ({ data, updateData, skip, goBack }) => {
  const [selected, setSelected] = useState(data.transport || '');

  useEffect(() => {
    setSelected(data.transport || '');
  }, [data.transport]);

  const isNextDisabled = !selected;

  const handleNext = () => {
    if (!isNextDisabled) {
      updateData('transport', selected);
    }
  };

  return (
    <div className="bg-white/60 backdrop-blur p-6 rounded-xl shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4 text-center">
        How will you travel to your destination?
      </h2>

      {/* Options Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
        {transportOptions.map(option => (
          <button
            key={option}
            onClick={() => setSelected(option)}
            className={`px-4 py-2 rounded-lg border text-sm transition-colors whitespace-nowrap
              ${selected === option
                ? 'bg-blue-500 text-white border-transparent'
                : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'}`}
          >
            {option}
          </button>
        ))}
      </div>

      {/* Navigation */}
      <div className="flex justify-between items-center">
        {/* Back button */}
        {goBack ? (
          <button
            onClick={goBack}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Back
          </button>
        ) : <div />} {/* empty div to keep spacing */}

        {/* Next & Skip */}
        <div className="flex items-center gap-2">
          <button
            onClick={handleNext}
            disabled={isNextDisabled}
            className={`px-6 py-2 rounded-lg transition 
              ${isNextDisabled
                ? 'bg-blue-300 text-white cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'}`}
          >
            Next
          </button>
          <button
            onClick={skip}
            className="px-6 py-2 bg-transparent border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepTransport;
